import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { TFunction } from 'i18next';
import { TParams } from '../../../types/translation.types';

type useTextReturnType = (tParams: TParams) => TFunction;

const useText = (): useTextReturnType => {
  const { t } = useTranslation();

  return useCallback(
    (tParams) => {
      if (typeof tParams === 'string') {
        return t(tParams);
      }
      return t(tParams.tKey, tParams.defaultValue, tParams.options);
    },
    [t]
  );
};

export default useText;
